import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b88636f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "行业资讯", -1))
const _hoisted_3 = {
  key: 0,
  class: "news-list"
}
const _hoisted_4 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "empty-state__icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-state__text" }, "暂无行业资讯", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-state__subtext" }, "请稍后再来查看", -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "news-item__cover" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "news-item__content" }
const _hoisted_12 = { class: "news-item__header" }
const _hoisted_13 = { class: "news-item__title" }
const _hoisted_14 = { class: "news-item__updated" }
const _hoisted_15 = { class: "news-item__footer" }
const _hoisted_16 = ["href"]

import { ref, onMounted } from 'vue';
import { getNewsCenterContent } from '@/api/product';

// --- 1. 定义接口 ---
interface NewsItem {
  id: number;
  title: string;
  cover: string; // 封面图片URL
  link: string;  // 跳转链接
  updated: string; // 更新时间，可以是 ISO 字符串或时间戳
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryView',
  setup(__props) {

const newsList = ref<NewsItem[]>([]);
const loading = ref<boolean>(true);
const error = ref<string | null>(null);
let current_type = '行业资讯';
const baseUrl = ref(process.env.VUE_APP_BASE_URL);

// 修正 GetNewsList 函数，使其返回 Promise 以便 onMounted 中的 async/await 能正确工作
const GetNewsList = (): Promise<NewsItem[]> => {
  return new Promise((resolve, reject) => {
    getNewsCenterContent(current_type)
      .then(res => {
        console.log(res);
        // 假设 res.data 就是 NewsItem[] 数组
        newsList.value = res.data;
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  return new Date(dateString).toLocaleString('zh-CN', options);
};

onMounted(async () => {
  try {
    loading.value = true;
    error.value = null;
    await GetNewsList(); // 等待数据加载完成
  } catch (err) {
    error.value = err instanceof Error ? err.message : '获取数据时发生未知错误';
    console.error('获取新闻列表失败:', err);
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!loading.value && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (newsList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(newsList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "news-item"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: baseUrl.value + item.cover,
                      alt: item.title
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h2", _hoisted_13, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(formatDate(item.updated).slice(0, 11)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("a", {
                        href: item.link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "news-item__read-more"
                      }, " 了解更多 ", 8, _hoisted_16)
                    ])
                  ])
                ]))
              }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})